import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getUpdateGame = (params) => {
    return axios.get(`${backendHost}/api/admin/games/list`);
};

export {
    getUpdateGame
}